import { render, staticRenderFns } from "./AccesoDenegado.vue?vue&type=template&id=0578050f"
import script from "./AccesoDenegado.vue?vue&type=script&lang=js"
export * from "./AccesoDenegado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports